module.exports = __webpack_public_path__ + "img/instalacion_pm.9de7d27f.png";